import { create } from 'zustand';
import { loginWithTelegram } from '../lib/api';
import { PlayerProfile } from '../shared/types';

interface AuthState {
  token: string | null;
  profile: PlayerProfile | null;
  status: 'idle' | 'loading' | 'ready' | 'error';
  error: string | null;
  login: () => Promise<void>;
  setProfile: (p: PlayerProfile) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  profile: null,
  status: 'idle',
  error: null,
  login: async () => {
    set({ status: 'loading', error: null });
    try {
      const { token, profile } = await loginWithTelegram();
      set({ token, profile, status: 'ready' });
    } catch (e: any) {
      set({ status: 'error', error: e.message ?? 'Ошибка авторизации' });
    }
  },
  setProfile: (profile) => set({ profile }),
}));
